import { useEffect, FC, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import env from '@beam-australia/react-env'
import { PaymentStatus, Receipt } from '../../../../UI'
import { history, isEmpty } from '../../../../../helpers'
import {
  getNewRepairListValue,
  getNewRepairListData,
  getNewRepairListPaymentOption,
  getNewRepairListExpediteOption
} from '../../../../../ducks/selectors'
import { configActions, newRepairListActions } from '../../../../../ducks/actions'
import { toast } from 'react-toastify'

const stripeKey = env('STRIPE_PUBLIC_KEY') ?? ''
const stripePromise = loadStripe(stripeKey)

const clientSecretIntent = new URLSearchParams(window.location.search).get(
  'payment_intent_client_secret'
) ?? ''

const ReceiptScreen: FC = () => {
  const dispatch = useDispatch()
  const replace = history.useReplace()

  const estimate = useSelector(getNewRepairListData())
  const clientSecret = useSelector(getNewRepairListValue('clientSecret'))
  const isExpedite = useSelector(getNewRepairListValue('isExpedite'))
  const paymentOption = useSelector(getNewRepairListPaymentOption())
  const expediteOption = useSelector(getNewRepairListExpediteOption())
  useEffect(() => { if (isEmpty(estimate)) replace('/') }, [estimate, replace])

  const handleExpediteSuccess = useCallback(() => {
    dispatch(configActions.setConfigValue({ type: 'overlayLoading', value: true }))
    dispatch(newRepairListActions.updateRepairList(expediteOption,
      (success, estimateId) => {
        if (success && estimateId) {
          toast.success('Repair List Updeated!')
          dispatch(newRepairListActions.setNewRepairListValues({
            attrs: { clientSecret: '', isExpedite: false, paymentOption: expediteOption }
          }))
        }
        dispatch(configActions.setConfigValue({ type: 'overlayLoading', value: false }))
      }))
  }, [dispatch, expediteOption])

  useEffect(() => {
    if (isExpedite && clientSecretIntent === clientSecret) {
      handleExpediteSuccess()
    }
  }, [clientSecret, handleExpediteSuccess, isExpedite])

  const handleSaveExpediteInfo = (clientSecret: string) => {
    dispatch(newRepairListActions.setNewRepairListValues({
      attrs: { clientSecret, isExpedite: true }
    }))
  }

  if (isEmpty(estimate)) return <div />

  return (
    <Elements stripe={stripePromise} options={{ clientSecret: clientSecretIntent ?? '' }}>
      <PaymentStatus
        clientSecret={clientSecretIntent}
        clear={() => dispatch(newRepairListActions.cleanNewRepairList())}
      >
        <Receipt
          estimate={estimate}
          paymentOption={paymentOption}
          expediteOption={expediteOption}
          onExpediteSuccess={handleExpediteSuccess}
          saveExpediteInfo={handleSaveExpediteInfo}
        />
      </PaymentStatus>
    </Elements>
  )
}
export default ReceiptScreen
